<h3 class="modal-header">
    <span>{{'NotificationSettings' | localize}}</span>
</h3>
<form nz-form nzLayout="vertical" #editForm="ngForm" (ngSubmit)="save()" *ngIf="settings">
    <h4>{{"ReceiveNotifications" | localize}}</h4>
    <nz-form-item>
        <nz-form-control [nzExtra]="l('ReceiveNotifications_Definition')">
            <nz-switch name="ReceiveNotifications" [ngModel]="settings.receiveNotifications" [nzCheckedChildren]="checkedTemplate"
                [nzUnCheckedChildren]="unCheckedTemplate"></nz-switch>
            <ng-template #checkedTemplate><i nz-icon nzType="check"></i></ng-template>
            <ng-template #unCheckedTemplate><i nz-icon nzType="close"></i></ng-template>
        </nz-form-control>
    </nz-form-item>

    <h4 *ngIf="settings.notifications.length">{{"NotificationTypes" | localize}}</h4>
    <p *ngIf="settings.notifications.length && !settings.receiveNotifications" class="text-red"><small>{{"ReceiveNotifications_DisableInfo" | localize}}</small>
    </p>
    <nz-form-item>
        <nz-form-control [nzExtra]="notification.description" *ngFor="let notification of settings.notifications">
            <label nz-checkbox name="Notification_{{notification.name}}" [nzDisabled]="!settings.receiveNotifications"
                [(ngModel)]="notification.isSubscribed">{{notification.displayName}}</label>
        </nz-form-control>
    </nz-form-item>
    <div class="modal-footer">
        <button nz-button type="button" [disabled]="saving" (click)="close()">
            {{"Cancel" | localize}}
        </button>
        <button nz-button [nzType]="'primary'" type="submit" [nzLoading]="saving">
            <i nz-icon nzType="save"></i> {{"Save" | localize}}
        </button>
    </div>
</form>